export { default } from './SupplementDetailsPopup';
